import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { PageDisplayer } from '../../../../ui'
import { JCAForm } from '../form'
import { useJCADetail } from '../../contexts'

export const JCADetail = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { jcaId } = useParams()
  const { formatMessage } = useIntl()
  const { loading, error, getJCA } = useJCADetail()

  useEffect(() => {
    getJCA(jcaId)
  }, [jcaId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/jca' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={loading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.jcaDetail.goBack' })}
    >
      {error ? (
        formatMessage({ id: 'pages.jcaDetail.error' })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {formatMessage({ id: 'pages.jcaDetail.title' })}
            </Typography>
          </Box>
          <JCAForm />
        </>
      )}
    </PageDisplayer>
  )
}
